import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { validate } from "compare-versions";
import { LicenseService } from "../../services/LicenseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";

@Component({
    styles:[require('./add-new-advertisement.component.css')],
    template:require('./add-new-advertisement.component.html')
})
export class AddNewAdvertisementDialogComponent{
    advertisementForm:FormGroup
    errorMessage="";
    uploadResponse="";
    validImage=false;
    submitted=false;
    imageBase64='';
    imageURL='';
    advertisementId=null;
    dialogTitle='';
    selectedAdvDetail;
    advertisementList=[];
    constructor(
        public dialogRef:MdDialogRef<AddNewAdvertisementDialogComponent>,
        @Inject(MD_DIALOG_DATA) public data:any,
        private formBuilder:FormBuilder,
        private licenseService:LicenseService,
        private appLoaderService:AppLoaderService,
        private  snackBar:MdSnackBar){
        this.buildForm();
        this.selectedAdvDetail=this.data.SelectedAdvData;
        this.advertisementList=data.Advlist;
        if(this.selectedAdvDetail){
            this.dialogTitle='Edit Advertisement'
            this.advertisementId=this.selectedAdvDetail.LZ30AdervertisementId
            this.imageBase64=this.selectedAdvDetail.ProductImage;
            this.advertisementForm.patchValue({
                ProductTitle:this.selectedAdvDetail.ProductTitle,
                ProductDescription:this.selectedAdvDetail.ProductDescription,
                ProductLink:this.selectedAdvDetail.ProductLink,
                ProductImage:this.imageBase64
            })
            this.imageURL=`data:image/jpg;base64,${this.imageBase64}`
        }
        else{
            this.dialogTitle='Add advertisement'
        }
    }
    buildForm(){
        this.advertisementForm=this.formBuilder.group({
            ProductTitle:['',[Validators.required, Validators.maxLength(30)]],
            ProductDescription:['',[Validators.required,Validators.maxLength(200)]],
            ProductLink:['',[Validators.required]],
            ProductImage:['',[Validators.required]]
        });
    }
    
    onChange(event){
        let imageFileList:FileList=event.target.files;
        this.uploadResponse='';
        if(imageFileList.length>0){

            let imageFile:File=imageFileList[0];
            let extension=imageFile.type.toLowerCase();
            if(!(extension =="image/jpg" || extension =="image/jpeg" || extension =="image/png")){
                this.imageBase64='';
                this.imageURL=''
                this.uploadResponse="The product image file can be in JPG/JPEG/PNG format only.";
                this.advertisementForm.controls['ProductImage'].setValue(this.imageBase64);
                this.advertisementForm.markAsDirty()
            }
            else{
                if(imageFile.size>=1048576){
                    this.imageBase64='';
                    this.imageURL=''
                    this.uploadResponse="The product image file cannot be greater than 1MB."
                    this.advertisementForm.controls['ProductImage'].setValue(this.imageBase64);
                    this.advertisementForm.markAsDirty()
                }
                else{
                    const reader=new FileReader();
                    reader.addEventListener("load",()=>{
                        if(typeof(reader.result)==='string'){
                            this.imageBase64=reader.result.split(',')[1];
                            this.imageURL=`data:${extension};base64,${this.imageBase64}`
                            this.advertisementForm.controls['ProductImage'].setValue(this.imageBase64);
                            this.advertisementForm.markAsDirty()
                        }    
                    });
                    reader.readAsDataURL(imageFile);
                }
            }
        }
        else{
            this.imageBase64='';
            this.advertisementForm.controls['ProductImage'].setValue(this.imageBase64);
            this.advertisementForm.markAsDirty()
            this.imageURL='';
            this.uploadResponse="Product image file is required."
        }  
    }
    onSubmit(){
        this.appLoaderService.open();
        if(this.selectedAdvDetail){
            let model={
                LZ30AdvertisementId:this.selectedAdvDetail.LZ30AdvertisementId,
                ProductTitle:this.advertisementForm.value.ProductTitle,
                ProductDescription:this.advertisementForm.value.ProductDescription,
                ProductLink:this.advertisementForm.value.ProductLink,
                ProductImage:this.imageBase64,
                IsActive:false,
                CreatedBy:Number(localStorage.getItem('userid')),
                UpdatedBy:Number(localStorage.getItem('userid'))
            }
            this.licenseService.updateAdvertisement(model).subscribe((data)=>{
                if(!data.IsError && data.DataObject!=null){
                    this.advertisementList=data.DataObject
                    this.snackBar.open("Advertisement updated successfully!","",{
                        duration:2000
                    });
                }
                else{
                    this.errorMessage="Advertisement is not updated. Please contact administrator.";
                }
                this.appLoaderService.close();
                this.dialogRef.close(this.advertisementList);
            })
        }
        else{
            let model={
                ProductTitle:this.advertisementForm.value.ProductTitle,
                ProductDescription:this.advertisementForm.value.ProductDescription,
                ProductLink:this.advertisementForm.value.ProductLink,
                ProductImage:this.imageBase64,
                IsActive:false,
                CreatedBy:Number(localStorage.getItem('userid')),
                UpdatedBy:Number(localStorage.getItem('userid'))
            }
            this.licenseService.addAdvertisement(model).subscribe((data)=>{
                if(!data.IsError && data.DataObject!=null){
                    this.advertisementList=data.DataObject;
                    this.snackBar.open("Advertisement added successfully!","",{
                        duration:2000
                    });
                }
                else{
                    this.errorMessage="Advertisement is not added. Please contact administrator.";
                }
                
                this.appLoaderService.close();
                this.dialogRef.close(this.advertisementList);
            })
        }
    }
    chooseFile(){
        document.getElementById('productImageInput').click();
    }
    onDialogCancel(){
        this.dialogRef.close(this.advertisementList);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/advertisement/add-new-advertisement/add-new-advertisement.component.ts